(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Qsched_direction', Qsched_direction);

    Qsched_direction.$inject = ['$resource'];

    function Qsched_direction ($resource) {
        var resourceUrl =  'api/qsched-directions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
